// @ts-nocheck

import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { OrderProcess as OrderProcessMobile } from './Mobile/OrderProcess'
import { OrderProcess as OrderProcessDesktop } from './Desktop/OrderProcess'
import { useWindowSize } from '../../../../hooks/useWindowSize'
import { Redirect } from 'react-router-dom'
import { ReduxState } from 'redux/rootReducer'
import { calculateTotalPrice } from 'utils/calculateTotalPrice'
import { trackMetaPurchase } from 'utils/metaPixel'

export const OrderProcess = () => {
  const { isMobile, isDesktop, isTablet } = useWindowSize()

  const { purchaseStatus, ticketState, purchaseId } = useSelector(
    (state: ReduxState) => state.CheckoutReducer.data
  )
  const coupon = useSelector(
    (state: ReduxState) => state.CheckoutReducer.coupon
  )

  const trackedPurchaseId = useRef(null)

  useEffect(() => {
    if (
      purchaseStatus === 'SUCCESS' &&
      purchaseId &&
      ticketState?.length &&
      trackedPurchaseId.current !== purchaseId
    ) {
      trackedPurchaseId.current = purchaseId

      trackMetaPurchase({
        value: calculateTotalPrice(ticketState, coupon),
        contentIds: ticketState.map((ticket) => ticket.id)
      })
    }
  }, [purchaseStatus, purchaseId, ticketState, coupon])

  if (isDesktop || isTablet) {
    return <OrderProcessDesktop />
  } else if (isMobile) {
    return <OrderProcessMobile />
  } else return <Redirect to="/checkout" />
}
